import $api from "@/shared/http";
import { toApiError } from "@/shared/http/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/app/appStore";
import { DEALER_SETTINGS_CLEAN_URL } from "../../lib/constants";
import { FetchStockPublicationPayload } from "./fetchStockPublicationSettings";
import { fetchStockPublicationSettings } from "./fetchStockPublicationSettings";

const extractErrorMessage = (error: unknown): string => {
  const apiError = toApiError(error);
  const detail =
    typeof apiError.data === "object" &&
    apiError.data !== null &&
    "detail" in apiError.data &&
    typeof (apiError.data as { detail: unknown }).detail === "string"
      ? (apiError.data as { detail: string }).detail
      : apiError.message;

  return detail || "Не удалось сбросить настройки";
};

export const cleanStockPublicationSettings = createAsyncThunk<
  FetchStockPublicationPayload,
  void,
  { rejectValue: string; state: RootState }
>(
  "stockPublication/cleanStockPublicationSettings",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      await $api.post(DEALER_SETTINGS_CLEAN_URL);
      const result = await dispatch(
        fetchStockPublicationSettings({ force: true }),
      );

      if (fetchStockPublicationSettings.rejected.match(result)) {
        return rejectWithValue(
          result.payload ?? "Не удалось загрузить настройки после сброса",
        );
      }

      return result.payload;
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error));
    }
  },
);
